import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import { Theme } from 'store/landing/types';

// variants depend on the widht of the parent
// for product pages where width is 1155 we use default
type CarouselVariant = Theme | 'search-bar' | 'frames-selector';

export interface CarouselElement extends HTMLElement {
  variant: CarouselVariant;
  label?: string;
  showProgressBar?: boolean;
}

const OpCarousel = createWrapper<CarouselElement>('op-carousel');

export default OpCarousel;
